import Vue from 'vue'
import Vuex from 'vuex'
//import { Request } from '@/network/request';
Vue.use(Vuex)
export interface State {
  user: {
      name: string;
  };
  loginState:boolean;
}


export default new Vuex.Store({
  state: {
    /**
     * 用户信息
     */
    user: {
        name: ''
    },
    /**
     * 登录状态
     */
    loginState: false
},
mutations: {
    /**
     * 设置用户登录状态
     */
    SET_LOGINSTATE(state:State, loginState: boolean) {
        state.loginState = loginState;
    },
    SET_NICK(state:State, nick: string) {
        state.user.name = nick;
    }
}
})